// src/landings/components/resources/RelatedCategories.tsx

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Category } from "../../../data/resources";

interface RelatedCategoriesProps {
  currentCategory: string; 
  categories: Category[];
}

function RelatedCategories({ currentCategory, categories }: RelatedCategoriesProps) {
  // Filter out current category and take up to 3 others
  const relatedCategories = categories
    .filter(c => c.id !== currentCategory)
    .slice(0, 3);
    
  if (relatedCategories.length === 0) {
    return null;
  }
    
  return (
    <section className="py-16 px-4 bg-[#fff5eb]">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-2xl font-bold mb-8 text-center text-[#694e42]">
          Explore Other Categories
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {relatedCategories.map((category, index) => (
            <motion.div
              key={category.id}
              className="bg-white rounded-xl shadow-sm overflow-hidden border border-[#e2dad3]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5, boxShadow: "0 12px 24px rgba(0,0,0,0.1)" }}
            >
              <Link to={`/resources/${category.id}`} className="block p-6">
                <div className="w-10 h-10 bg-[#fff5eb] rounded-lg flex items-center justify-center mb-4">
                  {category.icon}
                </div>
                <h3 className="text-lg font-bold text-[#694e42] mb-2">{category.title}</h3>
                <p className="text-sm text-[#8a7266]">{category.description}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelatedCategories;